import React from 'react'
import LoginLogs from '../../myapp/acc-stmt/login-logs'


function LoginLogsReport() {
  return (
    <LoginLogs/>
  )
}

export default LoginLogsReport


